import React from 'react';
import {
  Typography,
  Button,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack'; // eslint-disable-line no-unused-vars
import PeopleIcon from '@mui/icons-material/People';
import PremiumHeader from '../../components/Header/PremiumHeader';
import { useLang, t } from '../../context/LanguageContext';
import T from '../../translations/index';
import client1 from '../../assets/logos/client1.png';
import client2 from '../../assets/logos/client2.png';
import client3 from '../../assets/logos/client3.png';
import client4 from '../../assets/logos/client4.png';
import client5 from '../../assets/logos/client5.png';
import client6 from '../../assets/logos/client6.png';
import client7 from '../../assets/logos/client7.png';
import client8 from '../../assets/logos/client8.png';
import client9 from '../../assets/logos/client9.png';
import client10 from '../../assets/logos/client10.png';
import tataPowerLogo from '../../assets/logos/tata power.png';
import steagLogo from '../../assets/logos/steag.png';
import '../common.css';
import './clients.css';
import Footer from '../../components/Footer/Footer';

const Clients = () => {
  const navigate = useNavigate();
  const { lang } = useLang();

  // eslint-disable-next-line no-unused-vars
  const handleNavClick = (e, path) => {
    e.preventDefault();
    
    switch (path) {
      case 'home':
        navigate('/');
        break;
      case 'about':
        navigate('/about');
        break;
      case 'services':
        navigate('/services');
        break;
      case 'projects':
        navigate('/projects');
        break;
      case 'clients':
        navigate('/clients');
        break;
      case 'careers':
        navigate('/careers');
        break;
      case 'hireus':
        navigate('/hireus');
        break;
      case 'contact':
        navigate('/contact');
        break;
      default:
        break;
    }
  };

  const clientsList = [
    {
      name: 'TPSC (Toshiba Power)',
      type: t(T.powerProject, lang),
      logo: client1,
      description: lang === 'hi' ? 'TPSC अनूपर एक प्रमुख थर्मल पावर परियोजना है। त्रिशिवनय ने पाइपिंग, बॉयलर घटकों और सहायक प्रणालियों सहित पूर्ण यांत्रिक संविदा का कार्य किया।' : 'TPSC Anuppur is a major thermal power project. Trishivanay executed full mechanical contracting including piping, boiler components, and auxiliary systems.',
      projects: ['Anuppur, M.P. — Mechanical Contracting']
    },
    {
      name: 'Lanco Infratech Ltd.',
      type: t(T.powerProject, lang),
      logo: client2,
      description: lang === 'hi' ? 'लैंको कोरबा एक कोयला आधारित थर्मल पावर प्लांट है। त्रिशिवनय ने संरचनात्मक कार्य, कन्वेयर प्रणाली और कोयला हैंडलिंग उपकरण स्थापना की।' : 'Lanco Korba is a coal-based thermal power plant. Trishivanay handled structural works, conveyor systems, and coal handling equipment installation.',
      projects: ['Korba, C.G. — Mechanical Works']
    },
    {
      name: 'Vedanta Aluminium & Power Plant',
      type: t(T.powerProject, lang),
      logo: client3,
      description: lang === 'hi' ? 'वेदांता झारसुगुड़ा परियोजना एल्यूमीनियम और बिजली उत्पादन पर केंद्रित है। त्रिशिवनय ने बॉयलर और सहायक प्रणालियों के लिए पूर्ण यांत्रिक स्थापना की।' : 'Vedanta Jharsuguda project focuses on aluminium and power production. Trishivanay carried out complete mechanical installation for boilers and auxiliary systems.',
      projects: ['Jharsuguda, Odisha — Power Mech']
    },
    {
      name: 'Adani Power Ltd.',
      type: t(T.powerProject, lang),
      logo: client4,
      description: lang === 'hi' ? 'गुजरात और गोड्डा, झारखंड में अडाणी पावर परियोजनाएं। त्रिशिवनय ने पाइपिंग, संरचनाओं और उपकरण निर्माण सहित पूर्ण यांत्रिक कार्य किए।' : 'Adani Power projects in Gujarat and Godda, Jharkhand. Trishivanay contributed to full mechanical works including piping, structures, and equipment erection.',
      projects: ['Gujarat — Power Mech', 'Godda, Jharkhand — Infrastructure']
    },
    {
      name: 'Maithon Power Ltd.',
      type: t(T.powerProject, lang),
      logo: client5,
      description: lang === 'hi' ? 'मैथन पावर धनबाद में 500MW थर्मल पावर प्लांट है। त्रिशिवनय ने बॉयलर पाइपिंग, टर्बाइन सहायक उपकरण और रखरखाव कार्य किए।' : 'Maithon Power is a 500MW thermal power plant in Dhanbad. Trishivanay executed boiler piping, turbine auxiliaries, and maintenance works.',
      projects: ['Dhanbad, Jharkhand — Mechanical Works']
    },
    {
      name: 'CLP India Pvt Ltd',
      type: t(T.powerProject, lang),
      logo: client6,
      description: lang === 'hi' ? 'CLP झज्जर, हरियाणा प्लांट। त्रिशिवनय ने कोयला हैंडलिंग प्रणाली, डक्टिंग और राख प्रबंधन समाधान संभाले।' : 'CLP Jhajjar, Haryana plant. Trishivanay handled coal handling systems, ducting, and ash management solutions.',
      projects: ['Jhajjar, Haryana — Power Mech Works']
    },
    {
      name: 'KSK Mahanadi Power Project',
      type: t(T.powerProject, lang),
      logo: client7,
      description: lang === 'hi' ? 'अकलतरा प्लांट कोयला आधारित बिजली उत्पादन पर केंद्रित है। त्रिशिवनय ने पाइपिंग, बॉयलर घटकों और संरचनात्मक कार्य किए।' : 'Akaltara plant focusing on coal-fired power generation. Trishivanay executed piping, boiler components, and structural works.',
      projects: ['Akaltara, C.G. — Mechanical Contracting']
    },
    {
      name: 'Ambuja Cement',
      type: t(T.powerProject, lang),
      logo: client8,
      description: lang === 'hi' ? 'अंबुजा भाटापारा सीमेंट प्लांट। त्रिशिवनय ने किल्न, कन्वेयर और सामग्री हैंडलिंग प्रणालियों सहित यांत्रिक कार्य प्रदान किए।' : 'Ambuja Bhatapara cement plant. Trishivanay provided mechanical works including kilns, conveyors, and material handling systems.',
      projects: ['Bhatapara, C.G. — Simar Infrastructure']
    },
    {
      name: 'NTPC Tandwa',
      type: t(T.powerProject, lang),
      logo: client9,
      description: lang === 'hi' ? 'NTPC तांडवा झारखंड में। त्रिशिवनय ने बॉयलर सहायक उपकरण, पाइपिंग और फैन स्थापना कार्य किए।' : 'NTPC Tandwa in Jharkhand. Trishivanay executed boiler auxiliaries, piping, and fan installation works.',
      projects: ['Jharkhand — Mechanical & Structural Work']
    },
    {
      name: 'BHEL Sagardigi',
      type: t(T.powerProject, lang),
      logo: client10,
      description: lang === 'hi' ? 'पश्चिम बंगाल में BHEL सागरदिघी प्लांट। त्रिशिवनय ने डक्ट, ESP और सहायक प्रणालियों सहित पूर्ण यांत्रिक स्थापना की।' : 'BHEL Sagardigi plant in West Bengal. Trishivanay performed complete mechanical installation including ducts, ESP, and auxiliary systems.',
      projects: ['W.B. — Mechanical & Piping Work']
    },
    {
      name: 'Tata Power Jamshedpur',
      type: t(T.powerProject, lang),
      logo: tataPowerLogo,
      description: lang === 'hi' ? 'टाटा पावर जमशेदपुर प्लांट। त्रिशिवनय ने कूलिंग टावर कार्य, पाइपिंग और उपकरण निर्माण किए।' : 'Tata Power Jamshedpur plant. Trishivanay executed cooling tower works, piping, and equipment erection.',
      projects: ['Jharkhand — Mechanical & Structural Works']
    },
    {
      name: 'NTPC Buxar (Chausa)',
      type: t(T.powerProject, lang),
      logo: client9,
      description: lang === 'hi' ? 'NTPC बक्सर चौसा। त्रिशिवनय ने बॉयलर, टर्बाइन सहायक उपकरण और पाइपिंग सहित एंड-टू-एंड यांत्रिक संविदा प्रदान की।' : 'NTPC Buxar Chausa. Trishivanay provided end-to-end mechanical contracting including boiler, turbine auxiliaries, and piping.',
      projects: ['Bihar — Full Mechanical Contracting']
    },
    {
      name: 'STEAG Energy Services (India) Pvt. Ltd.',
      type: t(T.powerProject, lang),
      logo: steagLogo,
      description: lang === 'hi' ? 'STEAG एनर्जी सर्विसेज, झारसुगुड़ा, ओडिशा। त्रिशिवनय ने इस स्वतंत्र बिजली परियोजना के लिए पाइपिंग, बॉयलर सहायक उपकरण और संरचनात्मक निर्माण कार्य किए।' : 'STEAG Energy Services, Jharsuguda, Odisha. Trishivanay executed piping, boiler auxiliaries, and structural erection works for this independent power project.',
      projects: ['Jharsuguda, Odisha — Mechanical Execution']
    },
    {
      name: 'NTPC NGSL Vedanta',
      type: t(T.powerProject, lang),
      logo: client9,
      description: lang === 'hi' ? 'NTPC NGSL वेदांता, ओडिशा। त्रिशिवनय ने कोयला हैंडलिंग, राख प्रबंधन और पाइपिंग प्रणालियों सहित पूर्ण यांत्रिक कार्य किए।' : 'NTPC NGSL Vedanta, Odisha. Trishivanay handled full mechanical works including coal handling, ash management, and piping systems.',
      projects: ['Jharsuguda, Odisha — Mechanical Works']
    },
    {
      name: 'North Karanpura Super Thermal Power Project (NKSTPP)',
      type: t(T.powerProject, lang),
      logo: client9,
      description: lang === 'hi' ? 'हजारीबाग, झारखंड। त्रिशिवनय ने पाइपिंग, संरचनात्मक निर्माण और बॉयलर सहायक उपकरण सहित भारी यांत्रिक संविदा किए।' : 'Hajaribag, Jharkhand. Trishivanay executed heavy mechanical contracting, including piping, structural erection, and boiler auxiliaries.',
      projects: ['Hajaribag, Jharkhand — Mechanical & Industrial Contracting']
    }
  ];

  const exploreActions = [
    { titleKey: 'viewAllClients', icon: <PeopleIcon />, path: '/clients' }
    /*{ title: 'Add New Client', icon: <WorkIcon />, path: '/add-client' },
    { title: 'View Client Projects', icon: <DescriptionIcon />, path: '/client-projects' }*/
  ];

  const handleActionClick = (path) => {
    if (path) navigate(path);
  };

  const renderClientCard = (client) => {
    const isNTPC = client.name.includes('NTPC');

    return (
      <div className="client-showcase-card" key={client.name}>
        {/* Full Logo Display */}
        <div className="client-logo-panel">
          {client.logo ? (
            <img src={client.logo} alt={`${client.name} logo`} className="client-full-logo" />
          ) : (
            <div className="client-logo-fallback">{client.logoFallback || client.name}</div>
          )}
          {isNTPC && <span className="client-strategic-badge">{t(T.strategicPartner, lang)}</span>}
        </div>

        {/* Card Body */}
        <div className="client-card-body">
          <div className="client-name-row">
            <h3 className="client-card-name">{client.name}</h3>
            <span className="client-type-pill power">⚡ {client.type}</span>
          </div>

          <p className="client-card-desc">{client.description}</p>

          <div className="client-projects-section">
            <span className="client-projects-label">{t(T.keyDeliverables, lang)}</span>
            <ul className="client-projects-list">
              {client.projects.map((project, i) => (
                <li key={i}>{project}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="routed-page">
      <PremiumHeader />

      {/* Hero Banner */}
      <section className="clients-hero-banner">
        <div className="clients-hero-bg" />
        <div className="clients-hero-overlay" />
        <div className="clients-hero-content">
          <div className="clients-hero-eyebrow">Trusted by India's Best</div>
          <h1 className="clients-hero-title">
            Our <span>Esteemed Clients</span>
          </h1>
          <p className="clients-hero-sub">{t(T.clientsPageSubtitle, lang)}</p>
        </div>
      </section>

      {/* Stats Bar */}
      <div className="clients-stats-bar">
        <div className="clients-stats-inner">
          {[
            { num: '15+', label: t(T.activeClients, lang) },
            { num: '50+', label: t(T.completedProjects, lang) },
            { num: '8+', label: 'States Covered' },
            { num: '100%', label: t(T.deliveryExcellence, lang) },
          ].map((s, i) => (
            <div className="clients-stat-item" key={i}>
              <div className="clients-stat-num">{s.num}</div>
              <div className="clients-stat-label">{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Main Content */}
      <div className="clients-content">
        <div className="clients-eyebrow">Our Portfolio</div>
        <h2 className="clients-section-title">{t(T.clientsPageTitle, lang)}</h2>
        <p className="clients-section-sub">
          Proven partnerships across India's leading power generation, cement, and industrial companies. Each project a testimony to quality, safety, and timely delivery.
        </p>

        <div className="clients-showcase-grid">
          {clientsList.map(client => renderClientCard(client))}
        </div>
      </div>

      {/* Partner Logos Strip */}
      <div className="clients-partner-strip">
        <div className="clients-partner-inner">
          <div className="clients-partner-label">Organizations &amp; EPC Contractors We've Worked With</div>
          <div className="clients-partner-logos">
            {['NTPC', 'Adani Power', 'Vedanta', 'Tata Power', 'BHEL', 'Lanco Infratech', 'CLP India', 'KSK Mahanadi', 'Ambuja Cement', 'Maithon Power', 'STEAG Energy', 'TPSC Toshiba', 'Power Mech', 'Simplex Infrastructure', 'Simar Infrastructure'].map((name, i) => (
              <div className="clients-partner-logo-item" key={i}>{name}</div>
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Clients;
